import React, { Component } from "react";
import * as s from "./CollectionInformation.module.scss";
import { P, BackgroundImage } from "src/views/shared/components";
import { Icons } from "src/libs/assets";
import { ISingleWordpressCollection } from "src/models";
import { inject, observer } from "mobx-react";
import { UIStore } from "src/stores";
import { createMarkup, stripHtmlFromString } from "src/libs/utils";
import AnimateHeight from "react-animate-height";
import { tx } from "src/libs/i18n";
import { Button } from "resource-centre-theme/src/views/shared/components";
import { useDownloadCollection } from "resource-centre-theme/libs/hooks/useDownloadCollection";

interface Props {
  collection: ISingleWordpressCollection;
  uiStore?: UIStore;
}

interface State {
  fullHeight: boolean;
}

@inject("uiStore")
@observer
export class CollectionInformation extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { fullHeight: false };
  }

  toggleHeight = () => {
    const { fullHeight } = this.state;
    this.setState({ fullHeight: !fullHeight });
  };

  renderShowMoreToggle = (isDesktop, fullHeight) => {
    let showMoreMaskClasses = [s.showMoreMask];
    let showMoreText = "Show More";

    if (fullHeight) {
      showMoreMaskClasses.push(s.fullHeight);
      showMoreText = "Show Less";
    }

    let renderTextToggle = () => {
      return (
        <div className={s.toggleShowMoreTextContainer}>
          <P className={s.toggleShowMoreText} onClick={this.toggleHeight}>
            {showMoreText}
          </P>
        </div>
      );
    };

    let renderChevronToggle = () => {
      let chevronContainerClasses = [s.chevronToggleContainer];

      if (fullHeight) {
        chevronContainerClasses.push(s.fullHeight);
      }

      return (
        <div
          className={chevronContainerClasses.join(" ")}
          onClick={this.toggleHeight}
        >
          <img
            src={Icons.chevronDown_small}
            alt="previous-page-icon"
            className={s.chevronIcon}
          />
        </div>
      );
    };

    return (
      <>
        {!isDesktop && renderChevronToggle()}
        <div className={s.toggleShowMoreRow}>
          <div className={showMoreMaskClasses.join(" ")} />
          {isDesktop && renderTextToggle()}
        </div>
      </>
    );
  };

  render() {
    const { fullHeight } = this.state;
    const { collection, uiStore } = this.props;
    const { collectionFields } = collection;
    const image = collection?.collectionThumbnail?.image;
    const { title, description, documents } = collectionFields;
    const { isDesktop } = uiStore;

    let collectionContentContainerClasses = [s.collectionContentContainer];
    let defaultHeight = isDesktop ? 300 : 260;

    if (fullHeight) {
      collectionContentContainerClasses.push(s.fullHeight);
    }

    return (
      <>
        <div className={s.collectionInformation}>
          {/* <div className={s.collectionCTAContainer}>
          <div className={s.subscribeWrapper}></div>
          <img
            src={Icons.subscribe_small}
            alt="subscribe-icon"
            className={s.ctaIcon}
          />
          <P className={s.subscribeText}>
            {tx("collection.subscribeToCollection")}
          </P>
        </div> */}

          <div className={collectionContentContainerClasses.join(" ")}>
            <AnimateHeight height={fullHeight ? "auto" : defaultHeight}>
              <P small className={s.collectionLabel}>
                {tx("collection.aboutCollection")}
              </P>
              <h6 className={s.collectionTitle}>{title}</h6>
              {image && (
                <div className={s.imageContainer}>
                  <BackgroundImage
                    image={image}
                    alt={"collection image"}
                    className={s.image}
                  />
                  {image?.caption && (
                    <P className={s.imageCaption}>
                      {tx("collection.imageCaption", {
                        caption: stripHtmlFromString(image?.caption),
                      })}
                    </P>
                  )}
                  {image?.description && (
                    <P className={s.imageDescription}>
                      {stripHtmlFromString(image?.description)}
                    </P>
                  )}
                </div>
              )}
              <P
                medium
                className={s.collectionDescription}
                dangerouslySetInnerHTML={createMarkup(description)}
              />
            </AnimateHeight>
          </div>

          {this.renderShowMoreToggle(isDesktop, fullHeight)}
        </div>
        <CollectionDownloadButton collection={collection} />
      </>
    );
  }
}

const CollectionDownloadButton = ({
  collection,
}: {
  collection: ISingleWordpressCollection;
}) => {
  const { downloadCollection, downloadInProgress } = useDownloadCollection();

  return (
    <Button
      disabled={downloadInProgress}
      size="medium"
      color="red"
      className={s.download}
      onClick={() => downloadCollection(collection)}
    >
      {downloadInProgress ? "Downloading..." : "Download Collection"}
    </Button>
  );
};
